import Box from "../library/box";
import { UpdateFuncType } from "./ElementListAdd";

import Form from "./Form";

const ElementListAddBox: React.FC<{
	element: Box;
	onUpdate: UpdateFuncType;
}> = ({ element, onUpdate }) =>
	element && (
		<Form>
			<Form.Labels>
				<Form.Field>Width</Form.Field>
				<Form.Field>Height</Form.Field>
				<Form.Field>Depth</Form.Field>
			</Form.Labels>
			<Form.Values>
				<Form.InputNumber name="width" value={element.width} onChange={onUpdate} />
				<Form.InputNumber name="height" value={element.height} onChange={onUpdate} />
				<Form.InputNumber name="depth" value={element.depth} onChange={onUpdate} />
			</Form.Values>
		</Form>
	);

export default ElementListAddBox;
